module.exports = __webpack_public_path__ + "img/icon-implantation-12.ca4be942.svg";